import {
  takeEvery, call, put, select,
} from 'redux-saga/effects';
import api from '../../api';
import { LINE_ITEMS_ACTION_TYPES, lineItemsActions, orderActions } from '../../actions';
import { URLS } from '../../constants';
import { lineItemsObjectsSelector } from '../../selectors/line_items';
import ga4DataLayer from '../../../services/ga4_datalayer';
import { assignLocation } from '../../../services/location_service';

// Post-discount unit price — what the user actually pays per unit.
// Matches the helper in cart/sagas/cart/index.js.
function netUnitPrice(lineItem) {
  const price = Number(lineItem.price) || 0;
  const discount = Number(lineItem.discount) || 0;
  const quantity = Math.max(Number(lineItem.quantity) || 1, 1);
  return price - discount / quantity;
}

export function* updateLineItemsQuantity(action) {
  function* onRequestComplete(response) {
    if (window.location.pathname.includes('/shop/checkout_now/')) {
      if (response.line_items.length === 0) {
        assignLocation(URLS.SHOP_PATH);
        return;
      }

      if (!response.user && response.line_items.filter(
        (lineItem) => lineItem.frequency > 0,
      ).length !== 0) {
        assignLocation(`${URLS.SHOP_PATH}?show_sign_in_for_product_subscription=true`);
        return;
      }
    }

    if (Object.keys(response.errors).length > 0) {
      const [[error]] = Object.values(response.errors);
      yield put(lineItemsActions.setError(error));
    }

    yield put(orderActions.orderLoaded(response));
    yield put(lineItemsActions.stopLoading({ id: action.payload.id }));
  }

  const lineItemAttrs = action.payload.order?.line_items_attributes?.[0];
  if (lineItemAttrs?.quantity === 0) {
    const lineItems = yield select(lineItemsObjectsSelector);
    const removedItem = lineItems.find((li) => li.id === action.payload.id);
    if (removedItem) {
      const itemForGa4 = { ...removedItem, price: netUnitPrice(removedItem) };
      ga4DataLayer.trackRemoveFromCart(itemForGa4, removedItem.quantity || 1);
    }
  }

  yield put(lineItemsActions.startLoading({ id: action.payload.id }));

  try {
    const response = yield call(api.updateLineItemsQuantity, action.payload);
    yield* onRequestComplete(response.data);
  } catch (error) {
    yield put(lineItemsActions.stopLoading({ id: action.payload.id }));
  }
}

export default function* lineItemsSaga() {
  yield takeEvery(LINE_ITEMS_ACTION_TYPES.UPDATE_QUANTITY_REQUEST, updateLineItemsQuantity);
}
